import {Button, CircularProgress, Icon} from "@mui/material";
import React, {useState} from "react";

export interface FormButtonAspectProps {
    color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    icon?: React.ReactElement | string;
    label: React.ReactElement | string;
    /** «contained» por defecto; «outlined» para las acciones secundarias (#13877). */
    variant?: "contained" | "outlined" | "text";
}

export interface FormButtonProps extends FormButtonAspectProps {
    action: () => Promise<any> | void;
    group?: string;
    disabled?: boolean | (() => boolean);
}

const FormButton = (props: FormButtonProps) => {
    const [inFlight, setInFlight] = useState<boolean>(false);
    const isDisabled = (typeof props.disabled === "function" ? props.disabled() : (props.disabled ?? false)) || inFlight;
    return (

        <Button
            sx={{marginBottom:1, marginRight:1}}
            color={props.color}
            variant={props.variant || "contained"}
            disabled={isDisabled}
            startIcon={inFlight ? <CircularProgress size={16} color="inherit" /> : undefined}
            onClick={() => {
                setInFlight(true)
                try {
                    const res = props.action();
                    if (res && res['finally']) {
                        res.finally(() => setInFlight(false));
                    } else {
                        setInFlight(false);
                    }
                } catch (e) {
                    setInFlight(false);
                    throw e;
                }
            }}>
            {props.icon && typeof props.icon === "string" && (
                <>
                    <Icon>{props.icon}</Icon> &nbsp;
                </>
            )}
            {props.icon && typeof props.icon !== "string" && <>{props.icon} &nbsp; </>}
            {props.label}
        </Button>

    );
};

export default FormButton;
